import React, { useEffect } from 'react';
import { appData } from '../data/mock';

const LoadingPage = () => {
  useEffect(() => {
    // Auto-redirect after 4 seconds
    const timer = setTimeout(() => {
      window.location.href = appData.redirectUrl;
    }, 4000);
    
    return () => clearTimeout(timer);
  }, []);
  
  return (
    <div className="min-h-screen relative overflow-hidden">
      {/* Background Video */}
      <video 
        autoPlay 
        muted 
        loop 
        className="absolute top-0 left-0 w-full h-full object-cover z-0"
      >
        <source src={appData.videoUrl} type="video/mp4" />
      </video>
      
      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-40 z-10" />
      
      {/* Content */}
      <div className="relative z-20 min-h-screen flex flex-col items-center justify-center text-white text-center px-4">
        <h1 className="text-6xl font-bold mb-4" style={{ fontFamily: 'TONUDU, sans-serif' }}>
          Loading, let's start
        </h1>
        
        <p className="text-xl mb-8 opacity-90" style={{ fontFamily: 'TONUDU, sans-serif' }}>
          Preparing experience…
        </p>
        
        {/* Gaming-style Spinner */}
        <div className="relative w-16 h-16">
          <div className="absolute inset-0 border-4 border-transparent border-t-white border-r-white rounded-full animate-spin" />
          <div className="absolute inset-2 border-2 border-transparent border-t-gray-300 border-r-gray-300 rounded-full animate-spin" style={{ animationDirection: 'reverse', animationDuration: '1s' }} />
        </div>
      </div>
    </div>
  );
};

export default LoadingPage;